import React, { useState, useEffect } from 'react';
import {View, Animated, Image} from 'react-native';

const cardClassImageDict = {
    "DEATHKNIGHT": require("./assets/img/class_small_deathknight.png"),
    "DEMONHUNTER": require("./assets/img/class_small_demonhunter.png"),
    "DRUID": require("./assets/img/class_small_druid.png"),
    "HUNTER": require("./assets/img/class_small_hunter.png"),
    "MAGE": require("./assets/img/class_small_mage.png"),
    "PALADIN": require("./assets/img/class_small_paladin.png"),
    "PRIEST": require("./assets/img/class_small_priest.png"),
    "ROGUE": require("./assets/img/class_small_rogue.png"),
    "SHAMAN": require("./assets/img/class_small_shaman.png"),
    "WARLOCK": require("./assets/img/class_small_warlock.png"),
    "WARRIOR": require("./assets/img/class_small_warrior.png"),
    "NEUTRAL": require("./assets/img/class_small_neutral.png")
}

const SmallClassImage = (props) => {

  const cardClass = props.card.cardClass
  const multiClassList = props.card.classes

  return (
    <>
    {
      multiClassList != null ? <AnimatedImage multiClassList={multiClassList}/> : <Image style={{width: 34, height: 34}} source={cardClassImageDict[cardClass]}/>
    }
    </>

  )
}

const AnimatedImage = (props) => {
  const fadeInOpacity = new Animated.Value(.75);
  const multiClassList = props.multiClassList

  useEffect(() => {
    Animated.sequence([
      Animated.timing(fadeInOpacity, {
        toValue: 1,
        duration: 2000,
        useNativeDriver: true
      })
    ]).start(event => {
        if (event.finished) {
          Animated.timing(fadeInOpacity, {
            toValue: .75,
            duration: 2000,
            useNativeDriver: true
          }).start(event => {
            setMultiClassIndex(multiClassIndex == multiClassList.length - 1 ? 0 : multiClassIndex + 1)
          })
        }})


  })

  const [multiClassIndex, setMultiClassIndex] = useState(0)

  return (
    <View>
      <Animated.Image style={{width: 34, height: 34, opacity: fadeInOpacity}} source={cardClassImageDict[multiClassList[multiClassIndex]]}/>
    </View>
  )
}

export default SmallClassImage;
